export function validateSpotRatesInput(spotRates: (Record<string, string> | null)): boolean {
    if (spotRates === null || spotRates === undefined) {
      return false
    }

    return spotRates.GBP && spotRates.GBP.match(/^[0-9]+\.?\d{0,9}$/) !== null
  }
